import { AfterContentInit, AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-tip',
  templateUrl: './tip.component.html',
  styleUrls: ['./tip.component.css']
})
export class TIPComponent implements AfterContentInit {

  constructor() {

  }

  ngAfterContentInit() {

  }
}
